//#region imports
import React, {useEffect, useState} from 'react';
//#endregion

const ReportPageHeader = (props) => {
    
    // title, description, rightContent
    const { title, description, rightContent } = props;

    return (
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            
            {/* left content */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>

                {/* title */}
                <span style={{
                    fontSize: '34px',
                    fontWeight: '600',
                }}>{title}</span>

                {/* description */}
                <span style={{
                    fontSize: '18px',
                    color: '#6b7280',
                }}>{description}</span>

            </div>

            {/* right content */}
            <div>
                {rightContent}
            </div>

        </div>
    );
};

export default ReportPageHeader;
